import { LocalizedForm } from "common/localization";

export default class AdminCertifiedModeEditForm extends LocalizedForm {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "name",
                    label: "ADMINISTRATION.CERTIFIED_MODE.EDIT.FIELDS.NAME_LABEL",
                    placeholder: "ADMINISTRATION.CERTIFIED_MODE.EDIT.FIELDS.NAME_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "isActive",
                    label: "ADMINISTRATION.CERTIFIED_MODE.EDIT.FIELDS.IS_ACTIVE_LABEL",
                    type: "checkbox",
                },
                {
                    name: "allowNonCertifiedContent",
                    label: "ADMINISTRATION.CERTIFIED_MODE.EDIT.FIELDS.ALLOW_NON_CERTIFIED_CONTENT_LABEL",
                    type: "checkbox",
                },
                {
                    name: "certifierUserIds",
                    label: "ADMINISTRATION.CERTIFIED_MODE.EDIT.FIELDS.CERTIFIERS_LABEL",
                    placeholder: "ADMINISTRATION.CERTIFIED_MODE.EDIT.FIELDS.CERTIFIERS_PLACEHOLDER",
                },
            ],
        };
    }
}
